module.exports = __webpack_public_path__ + "static/media/hero-image-left.d18786e9.png";